export const INITIAL_COUPON_HISTORY_STATE = {
  couponHistoryList: [],
  isLoadingCouponHistoryList: false,
  loadCouponHistoryError: false
}

export const ACTIONS_HISTORY = {
  LOADING_HISTORY_LIST: "LOADING_HISTORY_LIST",
  LOAD_SUCCESS: 'LOAD_SUCCESS',
  LOAD_FAILURE: 'LOAD_FAILURE',
  RESET_HISTORY_LIST: "RESET_HISTORY_LIST",
}

export const couponHistoryReducer =  (state, action) => {
  switch (action.type){
    case ACTIONS_HISTORY.LOADING_HISTORY_LIST: {
      return  {...state, isLoadingCouponHistoryList: action.payLoad}
    }
    case ACTIONS_HISTORY.LOAD_SUCCESS: {
      return  {...state, isLoadingCouponHistoryList: false, couponHistoryList: action.payLoad}
    }
    case ACTIONS_HISTORY.LOAD_FAILURE: {
      return  {...state, loadCouponHistoryError: action.payLoad}
    }
    case ACTIONS_HISTORY.RESET_HISTORY_LIST: {
      return {...state, couponHistoryList: action.payLoad}
    }
  }
}